import React, { FC, ReactElement, Suspense } from 'react';
import ConnectorInventorySkeletonLoader from './components/ConnectorInventorySkeletonLoader';
import ConnectorInventoryPage from './main';

const ConnectorInventory: FC = (): ReactElement => {
  return (
    <Suspense fallback={<ConnectorInventorySkeletonLoader />}>
      <ConnectorInventoryPage />
    </Suspense>
  );
};

export default ConnectorInventory;
